<template>
  <div>
    <v-row justify="center" class="mt-1">
      <v-col cols="8" lg="8" sm="12" md="12" class="pt-0 mt-0">
        <v-data-table
          dense
          :headers="headers"
          :items="items"
          :loading="loadingTable"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, 200],
          }"
          fixed-header
          height="70vh"
          :search="search"
          disable-sort
          hide-default-header
          calculate-widths
        >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th class="footer" v-for="(h, i) in headers" :key="i">
                  <span>{{ h.text }}</span>
                </th>
                <th class="footer">
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="sortData"
                        >mdi-sort</v-icon
                      >
                    </template>
                    <span>Sort</span>
                  </v-tooltip>
                </th>
              </tr>
            </thead>
          </template>

          <template v-slot:top>
            <v-row class="pb-1" align="center">
              <v-col cols="8" class="pl-0">
                <v-text-field
                  v-model="search"
                  label="Search..."
                  class="mx-4"
                  outlined
                  dense
                  hide-details="auto"
                  append-icon="mdi-magnify"
                  color="accent"
                ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>
              <v-col cols="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="accent"
                      v-bind="attrs"
                      v-on="on"
                      @click="filterData"
                      >Blanks
                      <v-icon right>{{
                        showOnlyBlanks ? "mdi-eye-off" : "mdi-eye"
                      }}</v-icon></v-btn
                    >
                  </template>
                  <span>{{
                    showOnlyBlanks ? "Show everything" : "Show only blanks"
                  }}</span>
                </v-tooltip>
              </v-col>

              <v-col cols="2">
                <v-btn color="success" @click="saveCategories"
                  >Save <v-icon right>mdi-check-outline</v-icon></v-btn
                ></v-col
              >
            </v-row>
          </template>
          <template v-slot:[`item.platformCategory`]="{ item }">
            <v-text-field
              class="my-1"
              dense
              outlined
              v-model="item.platformCategory"
              hide-details="auto"
              :rules="[rules.specialCharacters]"
            ></v-text-field>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-----------------STATUS DIALOG--------------------------------------------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
        :textColor="textColor"
      ></status-info>
    </v-dialog>
    <!---------------------------------------------------------------------------------->
  </div>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo.vue";
export default {
  name: "ShopifyCategoryMapping",
  components: {
    StatusInfo,
  },
  props: {
    platform: String,
  },
  computed: {},
  data: () => ({
    statusDialog: false,
    pending: false,
    responseMessage: "",
    filename: "",
    textColor: "basic--text",
    loadingTable: false,
    items: [],
    genders: [],

    headers: [
      { text: "CATEGORY", value: "category", class: "footer" },
      {
        text: "PLATFORM CATEGORY",
        value: "platformCategory",
        class: "footer",
      },
    ],
    rules: {
      specialCharacters: (v) =>
        !/[;,.]/.test(v) || "No special characters are allowed!",
    },
    search: "",
    sortedAsc: false,
    showOnlyBlanks: false,
  }),
  async mounted() {
    // await this.getCategoriesList();
    this.items = await this.getCategories();
    this.notFilteredItems = this.items;
  },
  methods: {
    async getCategories() {
      let action = "";
      if (this.platform == "bcfashion.com") {
        action = "getBCFashionCategories";
      }
      if (this.platform == "bcf.lt") {
        action = "getBCFCategories";
      }
      try {
        this.loadingTable = true;
        const response = await this.$store.dispatch(action);
        console.log("resp", response);
        this.loadingTable = false;
        return response.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    async saveCategories() {
      this.statusDialog = true;
      this.pending = true;
      let action = "";
      if (this.platform == "bcf.lt") {
        action = "postBCFCategories";
      }
      if (this.platform == "bcfashion.com") {
        action = "postBCFashionCategories";
      }

      try {
        let data = await this.formatCategoriesToBackend();
        const response = await this.$store.dispatch(action, data);
        console.log(response);
        this.pending = false;
        this.responseMessage = "Categories updated successfully!";
        this.filename = "completed.png";
      } catch (error) {
        console.log(error);
        this.textColor = "red--text";
        this.pending = false;
        this.responseMessage = error.response.data;
        if (error.response) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          // anything else
          this.filename = "feeling_blue.svg";
          this.responseMessage = "SORRY... Something went wrong.";
        }
      }
    },
    //send only filled categories
    async formatCategoriesToBackend() {
      let result = {};
      result = this.items.filter((el) => el.platformCategory);
      result = result.map((el) => {
        el.platformCategory = el.platformCategory.trim();
        return el;
      });
      return result;
    },
    //sort data so that filled categories will be on top or opposite
    sortData() {
      if (this.sortedAsc) {
        this.items = this.items.sort((a, b) => {
          if (
            a.platformCategory == undefined &&
            b.platformCategory == undefined
          )
            return 0;
          if (a.platformCategory == undefined) return 1;
          if (b.platformCategory == undefined) return -1;
          if (a.platformCategory > b.platformCategory) return 1;
          if (a.platformCategory < b.platformCategory) return -1;
          if (a.platformCategory == b.platformCategory) return 0;
        });
        this.sortedAsc = false;
      } else {
        //sort categories so that categories which do not have platformCategory will be on top of the list
        this.items = this.items.sort((a, b) => {
          if (
            a.platformCategory == undefined &&
            b.platformCategory == undefined
          )
            return 0;
          if (a.platformCategory == undefined) return -1;
          if (b.platformCategory == undefined) return 1;
          if (a.platformCategory > b.platformCategory) return -1;
          if (a.platformCategory < b.platformCategory) return 1;
          if (a.platformCategory == b.platformCategory) return 0;
        });
        this.sortedAsc = true;
      }
    },
    //filter data , show only blank ebay categories or show everything
    filterData() {
      if (this.showOnlyBlanks) {
        this.items = this.notFilteredItems;
        this.showOnlyBlanks = false;
      } else {
        this.items = this.items.filter((item) => !item.platformCategory);
        this.showOnlyBlanks = true;
      }
    },
    closeStatusDialog() {
      this.statusDialog = false;
      this.getCategories();
    },
    showErrors(status, message) {
      // client received an error response (5xx, 4xx)
      this.responseMessage = message;
      switch (status) {
        case 400:
          this.filename = "empty.png";
          break;
        case 401:
          //clear local storage, push to login
          localStorage.clear();
          this.$router.push("login");
          break;
        case 403:
          this.filename = "403_forbidden.png";
          break;
        case 404:
          this.responseMessage = "Bad request. Please contact TECH team.";
          this.filename = "void.png";
          break;
        case 500:
          this.filename = "server_down.png";
      }
    },
  },
};
</script>
